module.exports = __webpack_public_path__ + "img/haojiao.10e916dc.png";